(function () {


	const scrollShowcase = () => {
    const images = document.querySelectorAll('.scroll-showcase_item');
    const box = document.querySelector('.scroll-showcase-box');

    let currentImageIndex = 0;
    let lastScrollY = window.scrollY;

    const handleScroll = () => {
        const boxRect = box.getBoundingClientRect();
        const scrollDelta = window.scrollY - lastScrollY;
        const isInViewport = boxRect.top <= 200 && boxRect.bottom > 0;
        if (isInViewport) {
            if (scrollDelta > 0) {

                const image = images[currentImageIndex];
                if (image) {
                    let currentOpacity = parseFloat(getComputedStyle(image).opacity);
										let currentScale = parseFloat(image.style.transform.match(/scale\(([^)]+)\)/)?.[1] || 0.8);
                    currentOpacity = Math.min(currentOpacity + 0.07, 1);
										currentScale = Math.min(currentScale + 0.01, 1);
                    image.style.opacity = currentOpacity;
										// image.style.transform = `scale(${currentScale})`;

                    if (currentOpacity >= 1 && currentImageIndex < images.length - 1) {
                        currentImageIndex++;
                    }
                }
            } else if (scrollDelta < 0) {

                if (currentImageIndex >= 0 && boxRect.bottom > window.innerHeight / 2) {
                    const image = images[currentImageIndex];
                    let currentOpacity = parseFloat(getComputedStyle(image).opacity);
										let currentScale = parseFloat(image.style.transform.match(/scale\(([^)]+)\)/)?.[1] || 1);
                    currentOpacity = Math.max(currentOpacity - 0.07, 0);
										currentScale = Math.max(currentScale - 0.07, 0.8);
                    image.style.opacity = currentOpacity;
										// image.style.transform = `scale(${currentScale})`;

                    if (currentOpacity <= 0 && currentImageIndex > 0) {
                        currentImageIndex--;
                    }
                }
            }
        } else {
          
            //images.forEach(img => (img.style.opacity = 0));
            //currentImageIndex = 0;
        }

        lastScrollY = window.scrollY;
    };

    window.addEventListener('scroll', handleScroll);
};


document.addEventListener('DOMContentLoaded', scrollShowcase);

	document.addEventListener("DOMContentLoaded", function () {
		scrollShowcase();
	});
})();
